require("turbolinks").start() //10kb of js
